import React, { useState, useEffect } from 'react'
import './ShiftManagementNav.css'
import { SingleDatePicker } from 'react-dates';
import { ShiftSwapView } from './ShiftSwaps/ShiftSwapView';
import { AdditionalWorkDaysView } from './AdditionalDays/AdditionalWorkDaysView';
import { SpecificDriverShiftsView } from './AdditionalDays/SpecificDriverShiftsView.jsx';
import { getShiftSwaps, getAdditionalWorkDays, getSpecificDriverShifts } from '../../../utils/drivers.js'
import { connect } from 'react-redux';
import LoadMask from '../../../../Utils/LoadMask/LoadMask.js';
import RotateArrow from '../../../../../icons/rotate-arrow.js';
import ManagedInOdooNotice from '../../ManagedInOdooNotice';

const ManagementView = () => {
  const [search, setSearch] = useState('');
  const [swaps, setSwaps] = useState([]);
  const [daysList, setDaysList] = useState([]);
  const [focused, setFocused] = useState(false);
  const [focused2, setFocused2] = useState(false);
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({
    type: '',
    startDate: '',
    endDate: '',
  })
  const [filterdData, setFilterdData] = useState({
    swaps: [],
    days: []
  })
  const [specificDriverShifts, setSpecificDriverShifts] = useState([]);
  const [specificDriverShiftsLoading, setSpecificDriverShiftsLoading] = useState(false);

  const handleChange = (name, value) => {
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const fetchData = async (params) => {
    setLoading(true)
    try {
      const dbSwaps = await getShiftSwaps(params)
      const dbWorkDays = await getAdditionalWorkDays(params)
      const filteredSwaps = dbSwaps.filter(item=>(item.status !== 'canceled' && item.status !== 'completed'))
      const filtereWorkdays = dbWorkDays.filter(item=>(item.status !== 'canceled' && item.status !== 'completed'))

     if (filters.type && (filters.type === 'canceled' || filters.type === 'completed' || filters.type === 'all')){
      setDaysList(dbWorkDays)
      setSwaps(dbSwaps)
      setFilterdData({
        swaps: dbSwaps,
        days: dbWorkDays
      })
     }else{
      setDaysList(filtereWorkdays)
      setSwaps(filteredSwaps)
      setFilterdData({
        swaps: filteredSwaps,
        days: filtereWorkdays
      })
     }
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSpecificDriverShifts = async (params) => {
     setSpecificDriverShiftsLoading(true);
     try {
        const response = await getSpecificDriverShifts(params);
        setSpecificDriverShifts(response);
     } catch (error) {
        console.log(error);
        setSpecificDriverShiftsLoading(false);
     } finally {
        setSpecificDriverShiftsLoading(false);
     }
  };

  useEffect(() => {
    fetchSpecificDriverShifts();

    function handleClickOutsideDropdown(event) {
         // If the click was NOT inside the dropdown, we close it
         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
         }
      }

      // We add the global listener
      document.addEventListener('mousedown', handleClickOutsideDropdown);

      // We clean up the listener when unmounting the component
      return () => {
         document.removeEventListener('mousedown', handleClickOutsideDropdown);
      };
  }, [])

  useEffect(() => {
    const { startDate, endDate, type } = filters;

    let params = {}

    if (startDate && endDate) {
      params.from_date = startDate.format('YYYY-MM-DD'),
        params.to_date = endDate.format('YYYY-MM-DD')
    }

    if (type) {
      params.status = type;
    }

    fetchData(params);
  }, [filters]);

  useEffect(() => {
    let filteredSwaps = [...swaps]
    let filteredDays = [...daysList]

    if (search.trim() !== "") {
      filteredSwaps = filteredSwaps.filter((item) => {
        const name = `${item.employee.user.first_name} ${item.employee.user.last_name} (${item.employee.user.username})`
        return name.toLowerCase().includes(search.toLowerCase())
      });

      filteredDays = filteredDays.filter((item) => {
        const name = `${item.employee.user.first_name} ${item.employee.user.last_name} (${item.employee.user.username})`
        return name.toLowerCase().includes(search.toLowerCase())
      });

      setFilterdData((prev) => ({ ...prev, swaps: filteredSwaps, days: filteredDays }))
    }

  }, [search])

  const [activeTab, setActiveTab] = useState("view");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = React.useRef(null);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
     <React.Fragment>
        <div className="shifts-management-nav__page-header">
           <div className="shifts-management-nav__header-top">
              <nav className="shifts-management-nav__nav-tabs">
                 <button
                    className={`shifts-management-nav__nav-tab ${activeTab === 'view' ? 'active' : ''}`}
                    onClick={() => handleTabClick('view')}
                 >
                    <svg
                       className="shifts-management-nav__nav-tab-icon"
                       fill="none"
                       stroke="currentColor"
                       viewBox="0 0 24 24"
                    >
                       <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                       />
                       <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                       />
                    </svg>
                    View Swaps
                 </button>

                 <button
                    className={`shifts-management-nav__nav-tab ${activeTab === 'additional-work-days' ? 'active' : ''}`}
                    onClick={() => handleTabClick('additional-work-days')}
                 >
                    <i className="fa fa-calendar-plus-o shifts-management-nav__nav-tab-icon" aria-hidden="true"></i>
                    Additional Work Days
                 </button>

                 <button
                    className={`shifts-management-nav__nav-tab ${activeTab === 'special' ? 'active' : ''}`}
                    onClick={() => handleTabClick('special')}
                 >
                    <svg
                       className="shifts-management-nav__nav-tab-icon"
                       fill="none"
                       stroke="currentColor"
                       viewBox="0 0 24 24"
                    >
                       <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                       />
                    </svg>
                    Special Shifts
                 </button>
              </nav>
           </div>

           <div className="shifts-management-nav__filters-section">
              <div className="shifts-management-nav__search-box">
                 <div className="shifts-management-nav__search-input-wrapper">
                    <svg
                       className="shifts-management-nav__search-icon"
                       fill="none"
                       stroke="currentColor"
                       viewBox="0 0 24 24"
                    >
                       <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                       />
                    </svg>
                    <input
                       type="text"
                       className="shifts-management-nav__search-input"
                       placeholder="Search employees..."
                       id="searchInput"
                       value={search}
                       onChange={(e) => setSearch(e.target.value)}
                    />
                 </div>
              </div>

              {activeTab !== 'special' && (
                 <React.Fragment>
                    <div className="shifts-management-nav__filter-group">
                       <label className="shifts-management-nav__filter-label">Status:</label>
                       <select
                          className="shifts-management-nav__filter-select"
                          id="statusFilter"
                          onChange={(e) => handleChange('type', e.target.value)}
                       >
                          <option value="">All Statuses</option>
                          <option value="pending">Pending</option>
                          <option value="approved">Approved</option>
                          <option value="denied">Denied</option>
                          <option value="completed">Completed</option>
                          <option value="canceled">Canceled</option>
                       </select>
                    </div>

                    {/* Date Filters */}
                    <div className="shifts-management-nav__filter-group">
                       <label htmlFor="date-from" className="shifts-management-nav__filter-label">
                          From:
                       </label>
                       <div className="form-control p-1">
                          <SingleDatePicker
                             id="date_input"
                             date={filters.startDate}
                             onDateChange={(newDate) => handleChange('startDate', newDate)}
                             focused={focused}
                             onFocusChange={({ focused }) => setFocused(focused)}
                             numberOfMonths={1}
                             isOutsideRange={() => false}
                             placeholder="2025-01-01"
                          />
                       </div>
                    </div>

                    <div className="shifts-management-nav__filter-group">
                       <label htmlFor="date-to" className="shifts-management-nav__filter-label">
                          To:
                       </label>
                       <div className="form-control p-1">
                          <SingleDatePicker
                             id="date_input2"
                             date={filters.endDate}
                             onDateChange={(newDate) => handleChange('endDate', newDate)}
                             focused={focused2}
                             onFocusChange={({ focused }) => setFocused2(focused)}
                             numberOfMonths={1}
                             isOutsideRange={(day) =>
                                filters.startDate ? day.isBefore(filters.startDate, 'day') : false
                             }
                             placeholder="2025-01-02"
                          />
                       </div>
                    </div>
                 </React.Fragment>
              )}
              {activeTab === 'special' && (
                 <button className="btn-filter" onClick={fetchSpecificDriverShifts} title="Refresh Data">
                    <div style={{ height: '1.25rem', display: 'flex' }}>
                       <RotateArrow className="h-100" />
                    </div>
                 </button>
              )}
           </div>
        </div>

        <ManagedInOdooNotice what="Shift swaps, additional work days and special shifts" />

        <LoadMask loading={loading || specificDriverShiftsLoading} light>
           {activeTab === 'view' && (
              <ShiftSwapView
                 data={filterdData.swaps}
              />
           )}
           {activeTab === 'additional-work-days' && (
              <AdditionalWorkDaysView
                 data={filterdData.days}
              />
           )}
           {activeTab === 'special' && (
              <SpecificDriverShiftsView
                 data={specificDriverShifts}
                 search={search}
              />
           )}
        </LoadMask>
     </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  user: state.login.userInfo,
});

export default connect(mapStateToProps)(ManagementView);
